import { Card, CardBody, CardHeader, Heading, Skeleton, Text, Box } from '@chakra-ui/react'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts'

export type LineSeriesConfig = {
  dataKey: string
  name: string
  color: string
}

type ChartRow = {
  [key: string]: string | number | undefined
}

type Props = {
  title: string
  subtitle?: string
  data: ChartRow[]
  xKey?: string
  series: LineSeriesConfig[]
  loading?: boolean
  height?: number
  emptyMessage?: string
}

export default function ReportLineChart({
  title,
  subtitle,
  data,
  xKey = 'date',
  series,
  loading = false,
  height = 300,
  emptyMessage = 'No data for the current filters.',
}: Props) {
  return (
    <Card>
      <CardHeader pb={2}>
        <Heading size="sm">{title}</Heading>
        {subtitle ? (
          <Text fontSize="xs" color="gray.500" mt={1}>
            {subtitle}
          </Text>
        ) : null}
      </CardHeader>
      <CardBody pt={0}>
        {loading ? (
          <Skeleton height={`${height}px`} />
        ) : data.length === 0 ? (
          <Text fontSize="sm" color="gray.500" py={8} textAlign="center">
            {emptyMessage}
          </Text>
        ) : (
          <Box h={`${height}px`} w="100%">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
                <XAxis dataKey={xKey} tick={{ fontSize: 11 }} />
                <YAxis tick={{ fontSize: 11 }} />
                <Tooltip />
                <Legend />
                {series.map((s) => (
                  <Line
                    key={s.dataKey}
                    type="monotone"
                    dataKey={s.dataKey}
                    name={s.name}
                    stroke={s.color}
                    strokeWidth={2}
                    dot={{ r: 3 }}
                  />
                ))}
              </LineChart>
            </ResponsiveContainer>
          </Box>
        )}
      </CardBody>
    </Card>
  )
}
